import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1111f732"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "generation-stats-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "main-title" }, "整体发电统计", -1))
const _hoisted_3 = { class: "top-section" }
const _hoisted_4 = { class: "efficiency-chart-wrapper" }
const _hoisted_5 = { class: "data-group" }
const _hoisted_6 = { class: "data-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "今天", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "kWh", -1))
const _hoisted_10 = { class: "data-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "本年", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "MWh", -1))
const _hoisted_14 = { class: "data-group" }
const _hoisted_15 = { class: "data-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "本月", -1))
const _hoisted_17 = { class: "value" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "MWh", -1))
const _hoisted_19 = { class: "data-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "累计", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "MWh", -1))
const _hoisted_23 = { class: "bottom-section" }
const _hoisted_24 = { class: "data-card" }
const _hoisted_25 = { class: "card-content" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "总装机容量", -1))
const _hoisted_27 = { class: "value" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "kWp", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-placeholder" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "#a9cde2"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M8 6h32v4H8zM8 42h32v-4H8zM14 6h4v36h-4zM20 6h4v36h-4zM26 6h4v36h-4zM32 6h4v36h-4zM8 12h32v-2H8zM8 18h32v-2H8zM8 24h32v-2H8zM8 30h32v-2H8zM8 36h32v-2H8z" })
  ])
], -1))
const _hoisted_30 = { class: "data-card" }
const _hoisted_31 = { class: "card-content" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "总发电功率", -1))
const _hoisted_33 = { class: "value" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "kW", -1))
const _hoisted_35 = { class: "gauge-chart-wrapper" }

import { computed, watch } from 'vue'
import * as echarts from 'echarts'
import { onMounted, ref } from 'vue'

interface GenerationStats {
  efficiency: number
  today: number
  thisYear: number
  thisMonth: number
  cumulative: number
  installedCapacity: number
  currentPower: number
  genEnergyRate: number
}

export default /*#__PURE__*/_defineComponent({
  props: {
    stats: null
  },
  setup(__props: any) {

const props = __props as {
  stats: GenerationStats
}

const chart = ref()


onMounted(() => {
  if (chart.value) {
    const chartInstance = echarts.init(chart.value)
    chartInstance.setOption(efficiencyChartOption.value)
    // 窗口大小变化时重新渲染图表
    window.addEventListener('resize', () => {
      chartInstance.resize()
    })
  }
  // 初始化 ECharts 实例
})
watch(
  () => props.stats,
  () => {
    if (chart.value) {
      const chartInstance = echarts.init(chart.value)
      chartInstance.setOption(efficiencyChartOption.value)
    }
  },
  {
    deep: true,
  },
)
// 上方大环形图的 ECharts 配置
const efficiencyChartOption = computed(() => ({
  title: {
    text: `${props.stats.genEnergyRate}%`,
    // text: `${props.stats.genEnergyRate}%`,
    subtext: '发电效率',
    left: 'center',
    top: '38%', // 微调垂直位置
    textStyle: {
      fontSize: 28,
      color: '#6563ff',
      fontWeight: 'bold',
    },
    subtextStyle: {
      fontSize: 14,
      color: '#909399',
    },
  },
  series: [
    {
      type: 'pie',
      radius: ['75%', '90%'],
      avoidLabelOverlap: false,
      hoverAnimation: false,
      label: {
        show: false,
      },
      data: [
        {
          value: props.stats.genEnergyRate,
          itemStyle: {
            color: '#6563ff',
          },
        },
        {
          value: 100 - props.stats.genEnergyRate,
          itemStyle: {
            color: '#eef2f8',
          },
        },
      ],
    },
  ],
}))

const powerGaugeOption = computed(() => ({
  series: [
    {
      type: 'gauge',
      radius: '100%',
      center: ['50%', '70%'],
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: props.stats.installedCapacity,
      splitNumber: 5,
      progress: {
        show: true,
        width: 10,
        itemStyle: {
          color: '#52c41a',
        },
      },
      pointer: { show: false },
      axisLine: {
        lineStyle: {
          width: 10,
          color: [[1, '#eef2f8']],
        },
      },
      axisTick: {
        distance: -15,
        splitNumber: 5,
        lineStyle: {
          width: 2,
          color: '#c0c4cc',
        },
      },
      splitLine: { show: false },
      axisLabel: { show: false },
      detail: { show: false },
      data: [{ value: props.stats.currentPower }],
    },
  ],
}))

return (_ctx: any,_cache: any) => {
  const _component_v_chart = _resolveComponent("v-chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          ref_key: "chart",
          ref: chart,
          class: "chart"
        }, null, 512)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, [
            _createTextVNode(_toDisplayString(__props.stats.today) + " ", 1),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, [
            _createTextVNode(_toDisplayString(__props.stats.thisYear) + " ", 1),
            _hoisted_13
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, [
            _createTextVNode(_toDisplayString(__props.stats.thisMonth) + " ", 1),
            _hoisted_18
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("span", _hoisted_21, [
            _createTextVNode(_toDisplayString(__props.stats.cumulative) + " ", 1),
            _hoisted_22
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("span", _hoisted_27, [
            _createTextVNode(_toDisplayString(__props.stats.installedCapacity) + " ", 1),
            _hoisted_28
          ])
        ]),
        _hoisted_29
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("span", _hoisted_33, [
            _createTextVNode(_toDisplayString(__props.stats.currentPower) + " ", 1),
            _hoisted_34
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_v_chart, {
            class: "chart",
            option: _unref(powerGaugeOption),
            autoresize: ""
          }, null, 8, ["option"])
        ])
      ])
    ])
  ]))
}
}

})